import { type CSSProperties } from 'react';
import { clsx } from 'clsx';
import styles from './Skeleton.module.css';

export function Skeleton({
  lines = 1,
  className,
  style,
}: {
  lines?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={clsx(styles.root, className)}
      style={style}
      aria-hidden="true"
    >
      {Array.from({ length: lines }, (_, index) => (
        <span key={index} className={styles.line} />
      ))}
    </div>
  );
}
